"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiResponseSchema = void 0;
const zod_1 = require("zod");
const ApiResponseSchema = (dataSchema) => zod_1.z.union([zod_1.z.object({ data: dataSchema }), zod_1.z.object({ error: zod_1.z.string() })]);
exports.ApiResponseSchema = ApiResponseSchema;
//# sourceMappingURL=api.js.map